import { getAIModelIcon } from '@/lib/get-icon';
import { Chip, ScrollShadow } from '@nextui-org/react';
import React from 'react';
import { CheckIcon } from '../icons/check-icon';
import { AIModel } from '@/types';
// import { useBreakpoint } from '@/lib/hooks/use-breakpoint';

const ProductFeatures = ({
  word_count,
  ai_model,
  model_version,
  has_tips,
  typeName,
  tested,
}: {
  word_count: number;
  ai_model: AIModel;
  model_version: string;
  typeName: string;
  has_tips: boolean;
  tested: boolean;
}) => {
  // const breakpoint = useBreakpoint();
  // const isMobile = breakpoint === 'sm' || breakpoint === 'xs';

  return (
    <ScrollShadow
      orientation="horizontal"
      hideScrollBar
      className="flex w-full gap-3 py-0.5 px-2"
    >
      {word_count > 0 && (
        <div className="flex min-w-fit items-center tracking-[.1px] text-dark dark:text-light">
          {word_count} Words
        </div>
      )}
      <div className="flex min-w-fit items-center tracking-[.1px] text-dark dark:text-light">
        {getAIModelIcon({
          iconName: ai_model.slug,
          className: 'h-[18px] w-[18px]',
        })}
        <div className="ml-2">{ai_model.name}</div>
      </div>
      <div className="flex min-w-fit items-center tracking-[.1px] text-dark dark:text-light">
        <Chip radius="sm">{model_version}</Chip>
      </div>
      {!!has_tips && (
        <div className="flex min-w-fit items-center tracking-[.1px] text-dark dark:text-light">
          <CheckIcon className="h-[18px] w-[18px] text-dark-900 ltr:mr-1 rtl:ml-2.5 dark:text-light-800" />
          Tips
        </div>
      )}
      {!!tested && (
        <div className="flex min-w-fit items-center tracking-[.1px] text-dark dark:text-light">
          <CheckIcon className="h-[18px] w-[18px] text-dark-900 ltr:mr-1 rtl:ml-2.5 dark:text-light-800" />
          Tested
        </div>
      )}
      {typeName === 'Image' && (
        <div className="flex min-w-fit items-center tracking-[.1px] text-dark dark:text-light">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4" />
            <path d="M12 13l0 9" />
            <path d="M9 19l3 3l3 -3" />
          </svg>
          <div className="ml-2">{'HQ Images'}</div>
        </div>
      )}
    </ScrollShadow>
  );
};

export default ProductFeatures;
